import React, { useState, useEffect } from 'react'
import ReactDOM from 'react-dom'

const Summary = ({ refetch, cart }) => {
    return <div className="happy-cart__summary">
        { Math.abs(cart.discount_summary) > 0 ?<div className="happy-cart__discount happy-cart__summary_node">
            <div className="happy-cart__summary-key">
                Ваша скидка:
            </div>
            <div className="happy-cart__summary-value">
                { cart.discount_summary_format }
            </div>
        </div> : null }
        <div className="happy-cart__total happy-cart__summary_node">
            <div className="happy-cart__summary-key">
                Итого: 
            </div>
            <div className="happy-cart__summary-value">
                { cart.summary_format }
                { (Math.abs(cart.discount_summary) > 0) ? <>
                    <br /><strike>{ cart.summary_base_format }</strike>
                </> : null }
            </div>
        </div>
    </div>
}

export default Summary